// extracted by mini-css-extract-plugin
module.exports = {"title-svg":"CardDrop_title-svg__M8EYo","rs-panel-header":"CardDrop_rs-panel-header__iLxIV"};